import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./style.module.scss";

const Button = React.forwardRef((props, ref) => {
  return (
    <button
      {...props}
      ref={ref}
      onClick={props.onClick}
      className={cx({
        [styles.button]: true,
        [styles.secondary]: props.secondary,
        [styles.nowrap]: props.nowrap,
      })}
      type={props.type}
    >
      {props.children}
    </button>
  );
});

Button.defaultProps = {
  secondary: false,
  nowrap: false,
  children: null,
  type: "button",
  onClick: null,
};

Button.propTypes = {
  onClick: PropTypes.func,
  secondary: PropTypes.bool,
  nowrap: PropTypes.bool,
  children: PropTypes.node,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
};

export default Button;
